/**
 * CL-SPECIFICATIONS-001B — Project Specifications permission editor (pure).
 */

export const PROJECT_SPECIFICATION_VIEW_PERMISSION_KEY = "canViewProjectSpecifications";
export const PROJECT_SPECIFICATION_MANAGE_PERMISSION_KEY = "canManageProjectSpecifications";

export const PROJECT_SPECIFICATION_PERMISSION_CONTROL_KEYS = Object.freeze([
  PROJECT_SPECIFICATION_VIEW_PERMISSION_KEY,
  PROJECT_SPECIFICATION_MANAGE_PERMISSION_KEY,
]);

export const PROJECT_SPECIFICATION_PERMISSION_CONTROL_LABELS = Object.freeze({
  [PROJECT_SPECIFICATION_VIEW_PERMISSION_KEY]: "View project specifications",
  [PROJECT_SPECIFICATION_MANAGE_PERMISSION_KEY]: "Manage project specifications",
});

export const PROJECT_SPECIFICATION_PERMISSION_EXPLANATIONS = Object.freeze({
  [PROJECT_SPECIFICATION_VIEW_PERMISSION_KEY]:
    "Open the project Specifications workspace (Admin or client portal) and view current instructions.",
  [PROJECT_SPECIFICATION_MANAGE_PERMISSION_KEY]:
    "Create, edit, issue, revise, and manage specification categories in the project workspace. Enabling manage also enables view. Role does not limit checked permissions.",
});

function clonePermissions(permissions = {}) {
  return { ...(permissions || {}) };
}

export function listProjectSpecificationPermissionControls() {
  return PROJECT_SPECIFICATION_PERMISSION_CONTROL_KEYS.map((key) => ({
    key,
    label: PROJECT_SPECIFICATION_PERMISSION_CONTROL_LABELS[key],
  }));
}

export function shouldShowSpecificationPermissionsSection() {
  return true;
}

export function applySpecificationPermissionToggle(permissions = {}, key = "", checked = false) {
  const next = clonePermissions(permissions);
  if (key === PROJECT_SPECIFICATION_MANAGE_PERMISSION_KEY) {
    next[PROJECT_SPECIFICATION_MANAGE_PERMISSION_KEY] = checked === true;
    if (checked === true) {
      next[PROJECT_SPECIFICATION_VIEW_PERMISSION_KEY] = true;
    }
    return next;
  }
  if (key === PROJECT_SPECIFICATION_VIEW_PERMISSION_KEY) {
    next[PROJECT_SPECIFICATION_VIEW_PERMISSION_KEY] = checked === true;
    if (checked !== true) {
      next[PROJECT_SPECIFICATION_MANAGE_PERMISSION_KEY] = false;
    }
    return next;
  }
  return next;
}

export function applyDeliberateSpecificationPermissionEdit({ permissions = {}, key = "", checked = false } = {}) {
  return applySpecificationPermissionToggle(permissions, key, checked);
}

export function isSpecificationPermissionControlChecked(key, permissions = {}) {
  return permissions?.[key] === true;
}

export function normalizeSpecificationPermissionsForAssignmentSave(
  permissions = {},
  { rawPermissions = null } = {}
) {
  const source = rawPermissions && typeof rawPermissions === "object" ? rawPermissions : permissions;
  const next = clonePermissions(permissions);
  if (typeof source?.[PROJECT_SPECIFICATION_VIEW_PERMISSION_KEY] === "boolean") {
    next[PROJECT_SPECIFICATION_VIEW_PERMISSION_KEY] =
      source[PROJECT_SPECIFICATION_VIEW_PERMISSION_KEY] === true;
  }
  if (typeof source?.[PROJECT_SPECIFICATION_MANAGE_PERMISSION_KEY] === "boolean") {
    next[PROJECT_SPECIFICATION_MANAGE_PERMISSION_KEY] =
      source[PROJECT_SPECIFICATION_MANAGE_PERMISSION_KEY] === true;
    if (next[PROJECT_SPECIFICATION_MANAGE_PERMISSION_KEY] === true) {
      next[PROJECT_SPECIFICATION_VIEW_PERMISSION_KEY] = true;
    }
  }
  return next;
}

export function applySpecificationManageImpliesView(permissions = {}, raw = {}) {
  const next = clonePermissions(permissions);
  if (next[PROJECT_SPECIFICATION_MANAGE_PERMISSION_KEY] === true
    && raw?.[PROJECT_SPECIFICATION_VIEW_PERMISSION_KEY] !== false) {
    next[PROJECT_SPECIFICATION_VIEW_PERMISSION_KEY] = true;
  }
  return next;
}
